/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { PostalAddress } from './';
import {
    PostalAddressFromJSON,
    PostalAddressFromJSONTyped,
    PostalAddressToJSON,
} from './';
import type { WorkplacePreference } from './';
import {
    WorkplacePreferenceFromJSON,
    WorkplacePreferenceFromJSONTyped,
    WorkplacePreferenceToJSON,
} from './';

/**
 * 
 * @export
 * @interface LocationAndWorkplacePreference
 */
export interface LocationAndWorkplacePreference {
    /**
     * 
     * @type {PostalAddress}
     * @memberof LocationAndWorkplacePreference
     */
    location: PostalAddress;
    /**
     * 
     * @type {WorkplacePreference}
     * @memberof LocationAndWorkplacePreference
     */
    workplacePreference: WorkplacePreference;
}

/**
 * Check if a given object implements the LocationAndWorkplacePreference interface.
 */
export function instanceOfLocationAndWorkplacePreference(value: object): value is LocationAndWorkplacePreference {
    if (!('location' in value) || value['location'] === undefined) return false;
    if (!('workplacePreference' in value) || value['workplacePreference'] === undefined) return false;
    return true;
}

export function LocationAndWorkplacePreferenceFromJSON(json: any): LocationAndWorkplacePreference {
    return LocationAndWorkplacePreferenceFromJSONTyped(json, false);
}

export function LocationAndWorkplacePreferenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): LocationAndWorkplacePreference {
    if (json == null) {
        return json;
    }
    return {
        
        'location': PostalAddressFromJSON(json['location']),
        'workplacePreference': WorkplacePreferenceFromJSON(json['workplacePreference']),
    };
}

export function LocationAndWorkplacePreferenceToJSON(value?: LocationAndWorkplacePreference | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'location': PostalAddressToJSON(value['location']),
        'workplacePreference': WorkplacePreferenceToJSON(value['workplacePreference']),
    };
}

